module.exports = __webpack_public_path__ + "img/Management.20dd2309.jpg";